module.exports = __webpack_public_path__ + "img/icon-coin.36b8ad9e.gif";